import store from '@/vuex/store';
import { ref, computed, watch } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useDisposes } from '@/composables/use-disposes';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { ChemicalEntryService } from '../service/chemical-entry.service';

export const useChemicalEntry = createGlobalState(() => {
    const chemicalEntryService = injectService<ChemicalEntryService>(ChemicalEntryService);

    const { disposes } = useDisposes();

    const state = ref(chemicalEntryService.state);
    disposes.push(chemicalEntryService.onStatesChange((newState) => {
        state.value = newState;
    }));

    const buttonVisible = computed(() => state.value.buttonVisible);
    function updateButtonVisible({ detail }: { detail: boolean }) {
        chemicalEntryService.updateButtonVisible(detail);
    }

    const highlightEnabled = computed(() => state.value.highlightEnabled);
    function updateHighlightEnabled({ detail }: { detail: boolean }) {
        chemicalEntryService.updateHighlightEnabled(detail);
    }
    watch(highlightEnabled, (enabled) => {
        if (enabled) {
            store.dispatch('bio/toggle', false);
        }
    }, { immediate: true });

    function getWujieProps() {
        return chemicalEntryService.getWujieProps();
    }

    return {
        buttonVisible,
        updateButtonVisible,
        highlightEnabled,
        updateHighlightEnabled,
        getWujieProps,
    };
});
